import { ActionOptionType } from '../../backers/constants/IndividualBackerConstants';
import PHE from '../../common/constants/PostHogEvents';

export enum ActionOptions {
  VIEW_STARTUP_DETAILS = 'View Startup Details',
  SHARE_DEAL_URL = 'Share Deal URL',
  CLOSE_DEAL = 'Close Deal',
  CANCEL_DEAL = 'Cancel Deal'
}
export const ActionOptionsList: ActionOptionType[] = [
  {
    label: ActionOptions.VIEW_STARTUP_DETAILS
  },
  {
    label: ActionOptions.SHARE_DEAL_URL
  }
];

export enum BackersForDealStatus {
  INVITED = 'invited',
  VIEWED = 'viewed',
  COMMITED = 'committed',
  TRANSFERRED = 'transferred'
}

export const TYPE_OF_COMMUNICATION_KEY: any = {
  [BackersForDealStatus.INVITED]: 'not_viewed',
  [BackersForDealStatus.VIEWED]: 'not_committed',
  [BackersForDealStatus.COMMITED]: 'not_transfered'
};

export const PHERemindBacker: any = {
  [BackersForDealStatus.INVITED]: PHE.RemindToCommitBackersTableInvitedTab,
  [BackersForDealStatus.VIEWED]: PHE.RemindToCommitBackersTableDealDetailViewedTab,
  [BackersForDealStatus.COMMITED]: PHE.RemindToCommitBackersTableDealDetailCommitedTab
};

export const PHERemindBackerSuccess: any = {
  [BackersForDealStatus.INVITED]: PHE.RemindToCommitBackersTableDealDetailInvitedTabSuccess,
  [BackersForDealStatus.VIEWED]: PHE.RemindToCommitBackersTableDealDetailViewedTabSuccess,
  [BackersForDealStatus.COMMITED]: PHE.RemindToCommitBackersTableDealDetailCommitedTabSuccess
};

export const PHERemindBackerFailed: any = {
  [BackersForDealStatus.INVITED]: PHE.RemindToCommitBackersTableDealDetailInvitedTabFailed,
  [BackersForDealStatus.VIEWED]: PHE.RemindToCommitBackersTableDealDetailViewedTabFailed,
  [BackersForDealStatus.COMMITED]: PHE.RemindToCommitBackersTableDealDetailCommitedTabFailed
};

export const PHEBulkRemindBacker: any = {
  [BackersForDealStatus.INVITED]: PHE.BulkRemindToCommitSelectedBackersTableInvitedTab,
  [BackersForDealStatus.VIEWED]: PHE.BulkRemindToCommitSelectedBackersTableDealDetailViewedTab,
  [BackersForDealStatus.COMMITED]: PHE.BulkRemindToCommitSelectedBackersTableDealDetailCommitedTab
};

export const PHEBulkRemindBackerSuccess: any = {
  [BackersForDealStatus.INVITED]: PHE.BulkRemindToCommitSelectedBackersTableDealDetailInvitedTabSuccess,
  [BackersForDealStatus.VIEWED]: PHE.BulkRemindToCommitSelectedBackersTableDealDetailViewedTabSuccess,
  [BackersForDealStatus.COMMITED]: PHE.BulkRemindToCommitSelectedBackersTableDealDetailCommitedTabSuccess
};

export const PHEBulkRemindBackerFailed: any = {
  [BackersForDealStatus.INVITED]: PHE.BulkRemindToCommitSelectedBackersTableDealDetailInvitedTabFailed,
  [BackersForDealStatus.VIEWED]: PHE.BulkRemindToCommitSelectedBackersTableDealDetailViewedTabFailed,
  [BackersForDealStatus.COMMITED]: PHE.BulkRemindToCommitSelectedBackersTableDealDetailCommitedTabFailed
};

export enum DealTabType {
  STARTUP_INFO = 'startup_info',
  SCHEME_INFO = 'scheme_info'
}

export const DEAL_FORM_TAB_OPTIONS: any = [
  {
    name: 'STARTUP INFO',
    value: DealTabType.STARTUP_INFO,
    content: ''
  },
  {
    name: 'SCHEME INFO',
    value: DealTabType.SCHEME_INFO,
    content: ''
  }
];

export const ManageCommitOptions = [
  {
    label: 'Investor should commit this minimum amount',
    value: '0'
  },
  {
    label: 'Investor should commit this exact amount',
    value: '1'
  },
  {
    label: 'Investor should be shown this exact amount but can be more also',
    value: '2'
  }
];
